import type {PostLoggingAccessParams} from 'domain/usecases/private/my-hospitalization/post-logging-access';
import {makePostLoggingAccess} from 'main/factories/usecases/private/my-hospitalization/post-logging-access-factory';

export const postLoggingAccess = async (params: PostLoggingAccessParams) => {
	await makePostLoggingAccess().post(params);
};
